import axios from 'axios';

class HttpRequestManager {
    GET(url, accessToken, responseType = null, retryOnError = true) {
        return new Promise(resolve => {
            var config = {
                headers: {}
            };

            // Only add Authorization header if token is valid
            if (accessToken && accessToken !== 'undefined') {
                config.headers.Authorization = "Bearer " + accessToken;
            }
            if (responseType) {
                config.responseType = responseType;
            }
            axios.get(url, config)
                .then(response => {
                    resolve(response);
                }).catch(err => {
                    if (err.response.status === 401) {
                        if (retryOnError) {
                            // Try to repeat once, the token may be expired
                            this.GET(url, accessToken, responseType, false).then(r => {
                                resolve(r);
                            });
                        }
                    }
                    resolve(err.response);
                });
        });
    }

    POST(url, accessToken, data, contentType = 'application/json', onuploadProgress = (p) => { }) {
        return new Promise(resolve => {
            var config = {
                headers: {
                    'content-type': contentType,
                },
                onUploadProgress(progressEvent) {
                    onuploadProgress({ progressEvent });
                }
            };

            // Only add Authorization header if token is valid
            if (accessToken && accessToken !== 'undefined') {
                config.headers.Authorization = "Bearer " + accessToken;
            }

            axios.post(url, data, config).then(response => {
                resolve(response);
            }).catch(err => {
                resolve(err.response);
            });
        });
    }

    PATCH(url, data, accessToken) {
        return new Promise(resolve => {
            var config = {
                headers: {}
            };

            // Only add Authorization header if token is valid
            if (accessToken && accessToken !== 'undefined') {
                config.headers.Authorization = "Bearer " + accessToken;
            }
            axios.patch(url, data, config).then(response => {
                resolve(response);
            }).catch(err => {
                resolve(err.response);
            });
        });
    }


    PUT(url, data, accessToken) {
        return new Promise(resolve => {
            var config = {
                headers: {}
            };

            // Only add Authorization header if token is valid
            if (accessToken && accessToken !== 'undefined') {
                config.headers.Authorization = "Bearer " + accessToken;
            }
            axios.put(url, data, config).then(response => {
                resolve(response);
            }).catch(err => {
                resolve(err.response);
            });
        });
    }

    DELETE(url, accessToken) {
        return new Promise(resolve => {
            var config = {
                headers: {}
            };

            // Only add Authorization header if token is valid
            if (accessToken && accessToken !== 'undefined') {
                config.headers.Authorization = "Bearer " + accessToken;
            }

            axios.delete(url, config)
                .then(response => {
                    resolve(response);
                }).catch(err => {
                    resolve(err.response);
                });
        });
    }
}

export const Portal = class Portal extends HttpRequestManager {
    constructor() {
        super();
        this.baseUrl = '/api'
    }

    makeEndpoint(ressource) {
        var endpoint = ressource;
        if (ressource.indexOf(this.baseUrl) < 0) {
            endpoint = `${this.baseUrl}${ressource}`;
        }
        return endpoint;
    }

    GET(ressource, token, responseType = null, retryOnError = true) {
        var endpoint = this.makeEndpoint(ressource);
        return super.GET(endpoint, token, responseType, retryOnError);
    }
    POST(ressource, token, data, contentType = null) {
        var endpoint = this.makeEndpoint(ressource);
        if (contentType) {
            return super.POST(endpoint, token, data, contentType);
        }
        else {
            return super.POST(endpoint, token, data);
        }

    }
    PATCH(ressource, token, data) {
        var endpoint = this.makeEndpoint(ressource);
        return super.PATCH(endpoint, data, token);
    }
    PUT(ressource, token, data) {
        var endpoint = this.makeEndpoint(ressource);
        return super.PUT(endpoint, data, token);
    }
    DELETE(ressource, token) {
        var endpoint = this.makeEndpoint(ressource);
        return super.DELETE(endpoint, token);
    }
    UPLOAD(ressource, token, data, onuploadProgress) {
        var endpoint = this.makeEndpoint(ressource);
        return super.POST(endpoint, token, data, "multipart/form-data", onuploadProgress);
    }
}